import * as React from 'react';
import { useRutubeVideoLink } from './hooks';
import * as styles from './styles.css';

export interface IRutubeProps {
  src: string;
}

export const RutubePlayer = ({ src }: IRutubeProps) => {
  const videoSrc = useRutubeVideoLink(src);

  return (
    <iframe
      width="100%"
      height="100%"
      className={styles['container']}
      src={videoSrc}
      frameBorder="0"
      allow="clipboard-write; autoplay"
      allowFullScreen
    />
  );
};
